export default "__VITE_ASSET__DaGqXVjJ__"